import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { useIsMobile } from '@sravni/react-utils';

import { isServer } from '@src/utils';

export function useAwayListener() {
  const isMobile = useIsMobile();
  const router = useRouter();
  const nextUrl = router?.query?.nextUrl as string | undefined;

  const touchStartY = useRef(0);

  useEffect(() => {
    if (!nextUrl && isServer) return;

    // Сохраняем текущий URL в истории, чтобы отловить `popstate`
    window.history.pushState(null, '', window.location.href);

    const handleMouseOut = (e: MouseEvent) => {
      const isLeavingTopLeft = e.clientY < 0 && e.clientX < 150 && !e.relatedTarget;

      if (isLeavingTopLeft) {
        if (nextUrl) {
          window.open(nextUrl, '_blank');
        }
        window.removeEventListener('mouseout', handleMouseOut);
      }
    };

    const handleTouchStart = (e: TouchEvent) => {
      touchStartY.current = e.touches[0].clientY;
    };

    const handleTouchEnd = (e: TouchEvent) => {
      const touchEndY = e.changedTouches[0].clientY;
      const deltaY = touchEndY - touchStartY.current;

      if (deltaY > 100) {
        if (nextUrl) {
          window.open(nextUrl, '_blank');
        }
        window.removeEventListener('touchend', handleTouchEnd);
      }
    };

    const handlePopState = () => {
      if (nextUrl) {
        window.open(nextUrl, '_blank');
      }
    };

    window.addEventListener('mouseout', handleMouseOut);
    window.addEventListener('popstate', handlePopState);

    if (isMobile) {
      window.addEventListener('touchstart', handleTouchStart);
      window.addEventListener('touchend', handleTouchEnd);
    }

    return () => {
      if (isMobile) {
        window.removeEventListener('touchstart', handleTouchStart);
        window.removeEventListener('touchend', handleTouchEnd);
      }
      window.removeEventListener('mouseout', handleMouseOut);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [nextUrl, isMobile]);
}
